import React from "react";
import {
  UnorderedList,
  Text,
  Box,
  Checkbox,
  Flex,
  ListItem,
} from "@chakra-ui/react";
import FormListItem from "./FormListItem";
import { formatDate } from "./utils";
import Header from "../FormListPage/Header";
const FormList = ({
  formSubmissions,
  handleAction,
  isChecked,
  allChecked,
  selectValue,
  onChangeCheckBox,
  onChangeEvent,
  onClickEvent,
}) => {
  const showFormKeys = () => {
    return Object.keys(formSubmissions[0])
      .filter((key) => {
        return !["formId", "ID", "address", "created", "filter"].includes(key);
      })
      .slice(0, 2);
  };
  const renderForms = () => {
    var formSubmissions2 = JSON.stringify(formSubmissions).replaceAll(
      /[A-Za-z]+\.[0-9]+\./gi,
      function () {
        return "";
      }
    );
    var formSubmissions3 = JSON.parse(formSubmissions2);
    const formsJSX = formSubmissions3.map((submission, index) => {
      const keys = showFormKeys();
      return (
        <FormListItem
          key={index}
          column1={submission[keys[0]]}
          column2={submission[keys[1]]}
          handleAction={handleAction}
          id={submission.id}
          onChangeCheckBox={onChangeCheckBox}
          isChecked={isChecked}
          allChecked={allChecked}
          created={formatDate(submission.created)}
        />
      );
    });
    return formsJSX;
  };

  const renderFormHeaders = () => {
    const customHeaders = showFormKeys().map((key, index) => {
      return (
        <>
          <Box key={key + index} p="3" w="30%">
            <Text textTransform="uppercase" fontWeight="600">{key}</Text>
          </Box>
        </>
      );
    });
    return (
      <>
        {customHeaders}
        <Box p="3" w="10%">
          <Text textTransform="uppercase" fontWeight="600">Date</Text>
        </Box>
        <Box p="3" w="30%">
          <Text textTransform="uppercase" fontWeight="600">Actions</Text>
        </Box>
      </>
    );
  };

  return (
    <div>
      {!formSubmissions.length ? (
        <Text>No forms was created yet!</Text>
      ) : (
        <div>
          <Flex paddingTop="12px" paddingBottom="10px">
            <Header
              selectValue={selectValue}
              onChangeEvent={onChangeEvent}
              onClickEvent={onClickEvent}
            />
            <Box
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "right",
                alignItems: "center",
              }}
            >
              {formSubmissions.length} items
            </Box>
          </Flex>

          <UnorderedList
            marginStart="0"
            className="form-list"
            borderRadius="4px"
            bg="#fff"
            styleType="none"
            border="1px solid #c3c4c7"
          >
            <ListItem className="form-list-item" w="100%">
              <Flex justify="space-between" w="100%">
                <Flex p="12px" alignItems="center">
                  <Checkbox
                    isChecked={allChecked}
                    onChange={(e) => {
                      onChangeCheckBox(e, "mainCheckBox");
                    }}
                  ></Checkbox>
                </Flex>
                {renderFormHeaders()}
              </Flex>
            </ListItem>
            {renderForms()}
            <ListItem className="form-list-item" w="100%">
              <Flex justify="space-between" w="100%">
                <Flex p="12px" alignItems="center">
                  <Checkbox
                    isChecked={allChecked}
                    onChange={(e) => {
                      onChangeCheckBox(e, "mainCheckBox");
                    }}
                  ></Checkbox>
                </Flex>
                {renderFormHeaders()}
              </Flex>
            </ListItem>
          </UnorderedList>
          <Flex paddingTop="10px">
            <Header
              selectValue={selectValue}
              onChangeEvent={onChangeEvent}
              onClickEvent={onClickEvent}
            />
            <Box
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "right",
                alignItems: "center",
              }}
            >
              {formSubmissions.length} items
            </Box>
          </Flex>
        </div>
      )}
    </div>
  );
};

export default FormList;
